import axios from 'axios';

export const state = {
  ipSignings: [],
  loading: false,
};

export const mutations = {
  setIpSignings(context, ipSignings) {
    context.ipSignings = ipSignings;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getIpSignings({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      commit('setLoading', true);
      const ipSignings = await axios.get(`${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/documents/admin/list/ip-signing?${query}`, options)
        .then(response => response);

      commit('setIpSignings', ipSignings.data);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
  async createIpSigningDocument(context, data) {
    return axios
      .post(`${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/ip-signing`, data)
      .catch(error => Promise.reject(error));
  },
};

const ipSigningsStore = {
  state,
  mutations,
  actions,
};

export default ipSigningsStore;



// WEBPACK FOOTER //
// ./src/store/ire/ipSigningsStore.js